function getCartData() {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        var url = "/cart.js";
        xhr.open("GET", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var cartData = JSON.parse(xhr.responseText);
                    resolve(cartData);
                } else {
                    reject("Failed to fetch cart data. Status: " + xhr.status);
                }
            }
        };
        xhr.send();
    });
}

const updates = {
    49724606284097: 0
};

const insuranceProductChecker = () => {
    getCartData()
        .then(({ items }) => {
            // Skip the cart-drawer shipping insurance line (properties.__addon === 'insurance').
            const fountItem = items.find(item => item.variant_id == '49724606284097' && !(item.properties && item.properties.__addon === 'insurance'));
            if (fountItem) {
                fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ id: fountItem.key, quantity: 0 })
                })
                    .then(response => {
                        // window.location.reload()
                        return response.json();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
insuranceProductChecker()
window.addEventListener("DOMContentLoaded", insuranceProductChecker)


  